<div
  fxLayout="column"
  [class.no-padding-container]="noPadding"
  [style.max-height]="enableScroll ? maxHeight : 'auto'">
  <div *ngIf="showKeyboardButton || showHelpButton" fxFlex="initial" fxFlexAlign="end">
    <button
      *ngIf="showKeyboardButton && !keyboardService.keyboardIsOpen()"
      mat-icon-button
      matTooltip="Abrir Teclado"
      (click)="keyboardService.openKeyboard()">
      <mat-icon class="keyboard-icon">keyboard</mat-icon>
    </button>
    <button
      *ngIf="showKeyboardButton && keyboardService.keyboardIsOpen()"
      mat-icon-button
      matTooltip="Fechar Teclado"
      (click)="keyboardService.closeKeyboard()">
      <mat-icon class="keyboard-icon">keyboard_hide</mat-icon>
    </button>
    <button *ngIf="showHelpButton" mat-button class="help"
      (click)="onClickHelpButton.emit()">Ajuda
      <mat-icon>help</mat-icon></button>
  </div>
  <div
    fxFlex
    class="dialog-body"
    [class.scrollable]="enableScroll"
    [class.no-padding]="noPadding"
    [ngClass]="scrollClass"
    [style.overflow-y]="enableScroll ? 'auto' : 'visible'"
    [style.min-height]="enableScroll ? '0' : 'auto'">
    <ng-content></ng-content>
  </div>
</div>
